import React from "react";
import { getReducedText } from "utils/utils";

const SupplierChangesSideBySide = (props) => {
  // Determine background color based on change type

  const { allChangesData, font_style, font_size } = props;

  const backgroundColor = {
    "-1": "bg-[#F0443826]",
    0: "",
    1: "bg-[#309C4426]",
  };

  return (
    <div className="">
      {allChangesData?.map((changeData, index) => {
        if (
          index === 0 ||
          allChangesData[index]?.supplier_changes_details_content !==
            allChangesData[index - 1]?.supplier_changes_details_opposite_content
        ) {
          return (
            <div className="grid grid-cols-2">
              <div
                className={`${
                  backgroundColor[
                    changeData?.supplier_changes_details_change_type === -1
                      ? "-1"
                      : 0
                  ]
                } h-fit border-r-2 primary-border-color`}
              >
                {
                  <p
                    className="my-0.5 px-2 py-2"
                    style={{
                      fontFamily: font_style,
                      fontSize: font_size,
                      lineHeight: 1,
                    }}
                  >
                    {changeData?.supplier_changes_details_change_type === 0
                      ? getReducedText(
                          changeData?.supplier_changes_details_content
                        )
                      : changeData?.supplier_changes_details_change_type === -1
                      ? changeData?.supplier_changes_details_content
                      : changeData?.supplier_changes_details_opposite_content
                          ?.length >= 1
                      ? changeData?.supplier_changes_details_opposite_content
                      : null}
                  </p>
                }
              </div>

              <div
                className={`${
                  backgroundColor[
                    changeData?.supplier_changes_details_change_type === 0
                      ? 0
                      : 1
                  ]
                } h-fit border-l-2 primary-border-color`}
              >
                {
                  <p
                    className="my-0.5 px-2 py-2"
                    style={{
                      fontFamily: font_style,
                      fontSize: font_size,
                      lineHeight: 1,
                    }}
                  >
                    {changeData?.supplier_changes_details_change_type === 0
                      ? getReducedText(
                          changeData?.supplier_changes_details_content
                        )
                      : changeData?.supplier_changes_details_change_type === 1
                      ? changeData?.supplier_changes_details_content
                      : changeData?.supplier_changes_details_opposite_content
                          ?.length >= 1
                      ? changeData?.supplier_changes_details_opposite_content
                      : null}
                  </p>
                }
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default SupplierChangesSideBySide;

// font-opensans
// font-mono
